import React, {useState, useEffect} from 'react';
import {Link, withRouter} from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import { formatCurrency } from 'utils';
import Filters from 'components/Filters/Filters';
import Placeholder from 'components/Placeholder';
import DateFilter from 'components/shared/DateFilter';
import withFiltering from 'hocs/withFiltering';
import BulkAction from '../ContactList/BulkActions/BulkAction';
import BulkActions from '../ContactList/BulkActions/BulkActions';
import StripePayoutList from './StripePayoutList';
import withDateFilter, { DATE_RANGES } from '../../hocs/withDateFilter';
import {actions as customerActions} from '../../ducks/customer';
import BulkExportAction from '../ContactList/BulkActions/BulkExportAction';

const filterFields = [
  {
    solr_prompt: 'payout_id',
    display_name: 'Payout Id',
    filter_type: 'TextFilter'
  },
  {
    solr_prompt: 'status',
    display_name: 'Status',
    filter_type: 'TextFilter'
  },
  {
    solr_prompt: 'amount',
    display_name: 'Amount',
    filter_type: 'NumberFilter'
  }
];

const StripePayoutReport = (props) => {
  const {
    location,
    filters,
    setFilters,
    dispatch,
    dateFilter,
  } = props;

  const [selectedFilters, setSelectedFilters] = useState(filters);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [enableQuickbooks, setEnableQuickbooks] = useState(false);

  useEffect(() => {
    const params = { ...dateFilter.queryParams, filters: JSON.stringify(selectedFilters) };
    setSummaryLoading(true);
    dispatch(customerActions.load()).then((response) => {
      setEnableQuickbooks(response.customer.modules.includes('quickbooks_export'))
    });
    fetch(`/api/stripe_payouts/summary?${new URLSearchParams(params)}`)
      .then(response => response.json())
      .then((json) => setSummary(json))
      .then(() => setSummaryLoading(false))
      .catch(() => {
        setSummaryLoading(false);
      })
  }, [dateFilter.queryParams, selectedFilters]);

  const downloadMessage = 'Your file is being prepared. You can safely close this modal and continue working. The '
    + 'report will automatically download when completed and will also be available on the User Jobs page.';

  const generateFilters = () => (
    <Filters
      fields={filterFields}
      selected={filters}
      submitFilters={newFilters => {
        setFilters(newFilters);
        setSelectedFilters(newFilters);
      }}
      itemsName='contacts'
    />
  );

  return (
    <div>
      <div className='stripe-payout-report-space-between'>
        <h2>Payout Report</h2>

        <BulkActions>
          <BulkAction title='Export' icon={faSignOut}>
            <BulkExportAction
              dispatch={dispatch}
              title='Export to CSV'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/export.csv'
              message={downloadMessage}
            />
            <BulkExportAction
              dispatch={dispatch}
              title='Export to PDF'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/export.pdf'
              message={downloadMessage}
            />
            <BulkExportAction
              dispatch={dispatch}
              title='Remittance Export to CSV'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/simplified_export.csv'
              message={downloadMessage}
            />
            <BulkExportAction
              dispatch={dispatch}
              title='Remittance Export to PDF'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/simplified_export.pdf'
              message={downloadMessage}
            />
            <BulkExportAction
              dispatch={dispatch}
              title='Export for FE NXT'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/fe_export'
              message={downloadMessage}
            />
            {enableQuickbooks && <BulkExportAction
              dispatch={dispatch}
              title='Export for Quickbooks'
              location={location}
              dateFilter={dateFilter}
              url='/api/stripe_payouts/quickbooks'
              message={downloadMessage}
            />}
          </BulkAction>
        </BulkActions>
      </div>

      <p>
        Your Stripe Payout Report downloads will be available&nbsp;
        <Link to='/setup/user_jobs'>here</Link>
        .
      </p>

      <DateFilter location={location} dateFilter={dateFilter} useAll={false} useFutureOptions={true} />

      <StripePayoutList
        dateFilter={dateFilter}
        summary={summary}
        loading={summaryLoading}
        generateFilters={generateFilters}
        filters={filters}
      />
    </div>
  );
};

StripePayoutReport.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }),
  filters: PropTypes.shape({}),
  setFilters: PropTypes.func,
  dispatch: PropTypes.func
};

StripePayoutReport.defaultProps = {
  location: {},
  filters: {},
  setFilters: () => false,
  dispatch: () => false
};

export default compose(
  withRouter,
  withFiltering,
  withDateFilter({ defaultRange: DATE_RANGES.last_7_days }),
  connect()
)(StripePayoutReport);
